import OUTLIERS_EXT_1 from "./OUTLIERS_EXT_1";
export default {
  OUTLIERS_EXT_1,
};
